{
  "cms.schedule.rowMarker.publish": "Julkaistaan {aika}",
  "cms.schedule.rowMarker.publishEdits": "Muutokset julkaistaan {aika}",
  "cms.schedule.rowMarker.unpublish": "Poistetaan julkaisusta {aika}"
}
